webpackJsonp([127],{

/***/ 2589:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CarouselSlide_vue__ = __webpack_require__(3262);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ff0c680_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CarouselSlide_vue__ = __webpack_require__(3766);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3764)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ff0c680"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CarouselSlide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ff0c680_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CarouselSlide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/base/carousel/CarouselSlide.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1ff0c680", Component.options)
  } else {
    hotAPI.reload("data-v-1ff0c680", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 3262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            index: 0
        };
    },

    computed: {
        visible: function visible() {
            return this.index === this.$parent.index;
        },
        dir: function dir() {
            console.log(this.$parent.slideDirection);
            return this.$parent.slideDirection;
        }
    }
});

/***/ }),

/***/ 3764:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3765);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("334af5ac", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1ff0c680\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CarouselSlide.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1ff0c680\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./CarouselSlide.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3765:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.slide-left-enter-active[data-v-1ff0c680] {\n    -webkit-animation: slide-left-in-data-v-1ff0c680 0.5s ease-in;\n            animation: slide-left-in-data-v-1ff0c680 0.5s ease-in;\n}\n.slide-left-leave-active[data-v-1ff0c680] {\n    -webkit-animation: slide-left-out-data-v-1ff0c680 0.5s ease-in;\n            animation: slide-left-out-data-v-1ff0c680 0.5s ease-in;\n}\n@-webkit-keyframes slide-left-in-data-v-1ff0c680{\nfrom  { -webkit-transform: translateX(-100%); transform: translateX(-100%);\n}\nto { -webkit-transform: translateX(0); transform: translateX(0);\n}\n}\n@keyframes slide-left-in-data-v-1ff0c680{\nfrom  { -webkit-transform: translateX(-100%); transform: translateX(-100%);\n}\nto { -webkit-transform: translateX(0); transform: translateX(0);\n}\n}\n@-webkit-keyframes slide-left-out-data-v-1ff0c680{\nfrom  { -webkit-transform: translateX(0%); transform: translateX(0%);\n}\nto { -webkit-transform: translateX(100%); transform: translateX(100%);\n}\n}\n@keyframes slide-left-out-data-v-1ff0c680{\nfrom  { -webkit-transform: translateX(0%); transform: translateX(0%);\n}\nto { -webkit-transform: translateX(100%); transform: translateX(100%);\n}\n}\n.slide-right-enter-active[data-v-1ff0c680] {\n    -webkit-animation: slide-right-in-data-v-1ff0c680 0.5s ease-in;\n            animation: slide-right-in-data-v-1ff0c680 0.5s ease-in;\n}\n.slide-right-leave-active[data-v-1ff0c680] {\n    -webkit-animation: slide-right-out-data-v-1ff0c680 0.5s ease-in;\n            animation: slide-right-out-data-v-1ff0c680 0.5s ease-in;\n}\n@-webkit-keyframes slide-right-out-data-v-1ff0c680{\nfrom  { -webkit-transform: translateX(0%); transform: translateX(0%);\n}\nto { -webkit-transform: translateX(-100%); transform: translateX(-100%);\n}\n}\n@keyframes slide-right-out-data-v-1ff0c680{\nfrom  { -webkit-transform: translateX(0%); transform: translateX(0%);\n}\nto { -webkit-transform: translateX(-100%); transform: translateX(-100%);\n}\n}\n@-webkit-keyframes slide-right-in-data-v-1ff0c680{\nfrom  { -webkit-transform: translateX(100%); transform: translateX(100%);\n}\nto { -webkit-transform: translateX(0); transform: translateX(0);\n}\n}\n@keyframes slide-right-in-data-v-1ff0c680{\nfrom  { -webkit-transform: translateX(100%); transform: translateX(100%);\n}\nto { -webkit-transform: translateX(0); transform: translateX(0);\n}\n}\n", ""]);

// exports


/***/ }),

/***/ 3766:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: _vm.dir } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.visible,
            expression: "visible"
          }
        ]
      },
      [_vm._t("default")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ff0c680", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/127.9c96f5e1231ef20f3d60.js